import React from 'react';
import { Grid, IconButton, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import RefreshIcon from '@material-ui/icons/Refresh';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import useDashboardStats from './hooks/useDashboardStats';
import SummaryStatsCards from './SummaryStatsCards';
import TransferStatsSection from './TransferStatsSection';
import VolumeStatsSection from './VolumeStatsSection';
import AgentStatsSection from './AgentStatsSection';
import KycStatsSection from './KycStatsSection';
import UserStatsSection from './UserStatsSection';
import PendingActionsSection from './PendingActionsSection';
const Dashboard = () => {
  const { stats, loading, error, refresh } = useDashboardStats();

  return (
    <PageContainer
      heading="Dashboard"
      headingAction={
        <IconButton onClick={refresh} disabled={loading} title="Refresh" size="small">
          <RefreshIcon />
        </IconButton>
      }
    >
      {error && (
        <Box mb={2}>
          <Alert severity="error" onClose={() => {}}>
            {error}
          </Alert>
        </Box>
      )}
      <GridContainer>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <SummaryStatsCards summary={stats.summary} loading={loading} />
          </Grid>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <PendingActionsSection pendingActions={stats.pendingActions} loading={loading} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <AgentStatsSection agents={stats.agents} loading={loading} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <KycStatsSection kyc={stats.kyc} loading={loading} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <UserStatsSection users={stats.users} loading={loading} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TransferStatsSection transfers={stats.transfers} loading={loading} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <VolumeStatsSection volume={stats.volume} loading={loading} />
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Dashboard;
